export const INVOICE_WORKFLOW_ACTION_LABEL: Record<string, string> = {
  approve_gl: 'Approve GL',
  reject_gl: 'Reject GL',
  down_payment: 'Bayar',
  full_payment: 'Set lunas',
  verify_lhu: 'Approve SPV Admin LHU',
  approve_manajer_teknis: 'Approve Manajer Teknis',
  customer_approve_lhu: 'Approve Customer',
  revisi_lhu: 'Revisi LHU',
  release_lhu: 'Rilis LHU',
  preview_lhu: 'Preview LHU',
  preview_invoice: 'PDF Invoice',
};

export const INVOICE_WORKFLOW_CONFIRM: Record<string, string> = {
  reject_gl: 'Tolak hasil uji? Status kembali ke Pengujian agar analis dapat memperbaiki.',
  full_payment: 'Catat sisa tagihan dan tandai invoice lunas (Full payment)?',
};
